;(function ( $, window, document, undefined ) {

  var pluginName = 'beOrder',
    defaults = {
      propertyName: "value"
    };

// The actual plugin constructor
  function Plugin(element, options) {
    this.element = element;
    this.$element = $(element);
    this.options = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;
    this.init();
  }

  Plugin.prototype.init = function () {
    var Plugin = this;
    Plugin.setEvents();
  };

  Plugin.prototype.setEvents = function () {
    var Plugin = this;

    var checkIn = Plugin.$element.find('.js-beOrder-checkin');

    Plugin.$element.find('.js-beOrder_number').on('input change', function() {
      checkIn.prop('disabled', false);
    });

    Plugin.$element.find('.js-beForm_fileUp').on('change', function() {
      checkIn.prop('disabled', false);
    })
  };

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function ( options ) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName,
          new Plugin( this, options ));
      }
    });
  }
})( jQuery, window, document );